import options from './chart-temperature.component';

export default {
    selector: 'dtChartTemperature',
    options
};
